/* eslint-disable */
export default {
  contactDetails: 'Dettagli contatto',
  loadingContact: 'Caricamento contatto...',
  contactNotFound: 'Contatto non trovato.',
} as const;

// @key: @#@"contactDetails"@#@ @source: @#@"Contact Details"@#@
// @key: @#@"loadingContact"@#@ @source: @#@"Loading contact..."@#@
// @key: @#@"contactNotFound"@#@ @source: @#@"Contact not found."@#@
